// Build-time API payloads embedded in prerendered snapshots (scripts/prerender.mjs).
// Only valid on the route the snapshot was rendered for.
let cache;

export function readPreload(key) {
  if (typeof document === "undefined") return undefined;
  const cur = window.location.pathname.replace(/\/+$/, "") || "/";
  if (document.documentElement.getAttribute("data-prerendered") !== cur) return undefined;
  if (cache === undefined) {
    try {
      cache = JSON.parse(document.getElementById("mps-preload")?.textContent || "{}");
    } catch {
      cache = {};
    }
  }
  return cache[key];
}
